import "./style.css"

const ShowCase = ()=>{

    return(
        <div className="showCaseServiceContent">
        <div className="showCaseServiceLeft">
            <h1>Upptäck vårt breda
            utbud av skräddarsydda
            massagebehandlingar</h1>
    
            <p>
            Erfarenheter av värk och smärta kan ofta hindra oss från att vara på vår bästa nivå.
            </p>
            <ul>
                <li>Perfekt för dig som spenderar långa timmar vid skrivbordet eller bakom ratten. </li>
                <li> Vår avstressande massage fokuserar på att förbättra cirkulation och exibilitet, samtidigt som den minskar smärta och stress.</li>
            </ul>
        </div>
    
        <div className="showCaseServiceImages">
                        <img src="https://images.pexels.com/photos/6629538/pexels-photo-6629538.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"/>
                        <img src="https://images.pexels.com/photos/275768/pexels-photo-275768.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"/>
                        <img src="https://images.pexels.com/photos/10893346/pexels-photo-10893346.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"/>
                        <img src="https://images.pexels.com/photos/6560298/pexels-photo-6560298.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2"/>
        </div>
        </div>
    )
}


export default ShowCase;